import { useMutation } from '@apollo/client';
import { Toggle } from '@fluentui/react';
import { TravelerExportInput } from 'common/types/globalTypes';
import React, { useState } from 'react';
import { TravelerRowItem } from '..';
import {
  TravelerExport,
  TravelerExportVariables,
} from './__generated__/TravelerExport';
import { ExportToCsv } from 'common/components/ExportToCsv';

import TRAVELER_LIST_EXPORT from './TravelerExport.graphql';
import { toSelection } from 'common/utils/entity';

interface ExportTravelersProps {
  selectedRows: TravelerRowItem[];
  isSelectedAllDefault: boolean;
}

export const ExportTravelers: React.FC<ExportTravelersProps> = ({
  selectedRows,
  isSelectedAllDefault,
}) => {
  const [isSelectedAll, setSelectedAll] = useState(isSelectedAllDefault);
  const [travelerExport] = useMutation<TravelerExport, TravelerExportVariables>(
    TRAVELER_LIST_EXPORT
  );

  const additionalComponents = (
    <Toggle
      inlineLabel
      label="All Travelers"
      checked={isSelectedAll}
      onChange={(_, value) => setSelectedAll(!!value)}
    />
  );

  const getExportCycle = async (description: string | undefined) => {
    const exportVariable: TravelerExportInput = {
      exportDescription: description,
      entitySelection: selectedRows.map(toSelection),
      isAllExported: isSelectedAll,
    };
    const { errors, data } = await travelerExport({
      variables: {
        input: exportVariable,
      },
    });

    return {
      id: data?.travelerExport?.exportResult?.exportCycles?.[0],
      errors,
    };
  };

  return (
    <ExportToCsv
      isButtonVisible={isSelectedAll || selectedRows.length > 0}
      title="Enter the description and press confirm to download the Traveler list."
      additionalComponents={additionalComponents}
      onDialogOpen={() => {
        setSelectedAll(isSelectedAllDefault);
      }}
      getExportCycle={getExportCycle}
    />
  );
};
